import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('article');

const GET_PARTNER_TRIPS = define('GET_PARTNER_TRIPS', true);

const CLEAR_LOCAL_EXPERT_STATUS_LIST = define('CLEAR_LOCAL_EXPERT_STATUS_LIST');
const GET_LOCAL_EXPERT_STATUS_LIST = define('GET_LOCAL_EXPERT_STATUS_LIST', true);

const initialState = {
  isLoadingTrips: false,
  trips: [],
  isLoadingLocalExpertStatusList: false,
  localExpertStatusList: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTNER_TRIPS.PENDING:
      return {
        ...state,
        isLoadingTrips: true,
      };
    case GET_PARTNER_TRIPS.RESOLVED:
      return {
        ...state,
        isLoadingTrips: false,
        trips: action.data
      };
    case GET_PARTNER_TRIPS.REJECTED:
      return {
        ...state,
        isLoadingTrips: false,
        trips: []
      };
    case GET_LOCAL_EXPERT_STATUS_LIST.PENDING:
      return {
        ...state,
        isLoadingLocalExpertStatusList: true,
      };
    case GET_LOCAL_EXPERT_STATUS_LIST.RESOLVED:
      return {
        ...state,
        isLoadingLocalExpertStatusList: false,
        localExpertStatusList: action.data
      };
    case GET_LOCAL_EXPERT_STATUS_LIST.REJECTED:
      return {
        ...state,
        isLoadingLocalExpertStatusList: false,
        localExpertStatusList: []
      };
    case CLEAR_LOCAL_EXPERT_STATUS_LIST:
      return {
        ...state,
        localExpertStatusList: []
      };
    default: return state;
  }
};

export const actions = {
  getPartnerTrips: (type) => ({
    type: GET_PARTNER_TRIPS,
    promise: api.get(`/trips/business-partner?type=${type}`),
    success: 'Load trips successfully',
    error: 'Fail to load trips',
  }),
  getLocalExpertStatusList: (tripId, date) => ({
    type: GET_LOCAL_EXPERT_STATUS_LIST,
    promise: api.get(`/users/business-partner?trip_id=${tripId}&date=${date}`),
    success: 'Load local expert data successfully',
    error: 'Fail to load local expert data',
  }),
  clearLocalExpertStatusList: () => ({
    type: CLEAR_LOCAL_EXPERT_STATUS_LIST,
  })
};



// WEBPACK FOOTER //
// ./src/ducks/partner.js